import { render, staticRenderFns } from "./PostVideoRelated.vue?vue&type=template&id=9e13a72e"
import script from "./PostVideoRelated.vue?vue&type=script&lang=js"
export * from "./PostVideoRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports